import PropTypes from 'prop-types';

function MMDairyAndEggsActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M10.3865 3.78418L7.29095 7.34368L11.8974 8.34543L14.2991 4.63403L10.3865 3.78418Z"
                fill="#F2EBD1"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.29095 7.34375C7.29095 7.34375 2.93908 26.1266 3.09098 26.3524C3.18952 26.4961 4.27338 26.763 5.31619 27.1735C6.19067 27.5225 7.50854 27.8756 7.50854 27.8756L11.8974 8.36192L7.29095 7.34375Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8974 8.3623C11.8974 8.3623 18.3677 9.59397 18.4663 9.78693C18.5648 9.97989 14.8739 27.9293 14.837 28.1058C14.7343 28.6149 14.5496 28.8941 13.0429 28.7586C11.1853 28.5727 9.33924 28.2862 7.5127 27.9006L11.8974 8.3623Z"
                fill="#F2EBD1"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8973 8.36198L14.2991 4.66699C14.2991 4.66699 16.8404 5.12681 17.173 5.29103C17.5055 5.45526 18.4662 9.80713 18.4662 9.80713L11.8973 8.36198Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9508 4.08409C12.0247 3.75975 12.271 2.65125 12.271 2.65125C12.271 2.65125 12.386 1.89994 12.8746 2.01489L15.2845 2.5363C15.2845 2.5363 16.081 2.64304 15.9824 3.09876C15.8839 3.55447 15.5719 4.88056 15.5719 4.88056L11.9508 4.08409Z"
                fill="#4B874B"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M16.8273 26.3815C13.6407 24.6353 14.333 18.3528 16.8273 17.694C20.1398 16.819 23.2264 21.6097 22.0147 24.5065C21.2304 26.3815 18.7264 27.4222 16.8273 26.3815Z"
                fill="#DEA455"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
            <path
                d="M18.9338 21.6169C17.3476 18.3478 21.5509 13.6274 23.9657 14.5351C27.1728 15.7404 26.9141 21.4336 24.2485 23.0931C22.5231 24.1673 19.8791 23.5653 18.9338 21.6169Z"
                fill="#FFF9EA"
                stroke="#2D2D2D"
                strokeWidth="0.5"
            />
        </svg>
    );
}

export default MMDairyAndEggsActive;

MMDairyAndEggsActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMDairyAndEggsActive.defaultProps = {
    className: null,
};
